import { observer } from 'mobx-react';
import { useState } from 'react';
import { ActionLockedIconWithTooltip } from '../../../../../../common/components/ActionLocked/ActionLockedIconWithTooltip';
import { useStore } from '../../../../../app/data/root.store';
import { CloseIcon } from '../../../VaultFilters/icons';
import {
    AddButton,
    RemoveTagButton,
    TagCategory,
    TagCategoryTitle,
    TagPill,
    TagsList,
    TagText
} from '../shared/TagCategory.styles';
import { SmartTagIcon } from './SmartTagIcon';
import { TagEditorModal } from './TagEditorModal';
import { PREDEFINED_TAG_NAMES } from '../../../../data/vault-store';

export const TagsTagCategory = observer(({ tags, onUpdate, onOpenTagEditorDrawer }) => {
    const { vaultStore, uiStore, userStore } = useStore();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleAddTag = () => {
        if (userStore.isActionBlockedByRole('editVaultFileMetadata')) {
            userStore.setShowLimitedSharedAccess(true);
            return;
        }
        if (uiStore.isDesktopView) {
            setIsModalOpen(true);
        } else {
            onOpenTagEditorDrawer(getSelectedTagObjects());
        }
    };

    const handleTagClick = () => {
        if (userStore.isActionBlockedByRole('editVaultFileMetadata')) {
            userStore.setShowLimitedSharedAccess(true);
            return;
        }
        if (uiStore.isDesktopView) {
            setIsModalOpen(true);
        } else {
            onOpenTagEditorDrawer(getSelectedTagObjects());
        }
    };

    const handleRemoveTag = (tagToRemove, event) => {
        if (userStore.isActionBlockedByRole('editVaultFileMetadata')) {
            userStore.setShowLimitedSharedAccess(true);
            return;
        }
        event.stopPropagation();
        const updatedTags = tags.filter(tag => tag !== tagToRemove);
        onUpdate(updatedTags);
    };

    const handleSaveTags = (selectedTags) => {
        const tagNames = selectedTags.map(tag => tag.id || tag.tag || tag.label);
        onUpdate(tagNames);
        setIsModalOpen(false);
    };

    const getSelectedTagObjects = () => {
        return tags.map(tagName => {
            return vaultStore.userTags.find(option =>
                option.label?.toLowerCase() === tagName.toLowerCase() ||
                option.id?.toLowerCase() === tagName.toLowerCase()
            ) || { id: tagName, label: tagName };
        }).filter(Boolean);
    };

    return (
        <TagCategory>
            <TagCategoryTitle>Tags {userStore.isActionBlockedByRole('editVaultFileMetadata') && <ActionLockedIconWithTooltip iconColor={'#ACB1BB'} isRoleBlocked={true} marginLeft={'0px'} />}</TagCategoryTitle>
            {tags.length > 0 && (
                <TagsList>
                    {tags.map((tag, index) => (
                        <TagPill key={index} onClick={handleTagClick}>
                            <SmartTagIcon tagName={tag} />
                            <TagText>{PREDEFINED_TAG_NAMES[tag] || tag}</TagText>
                            <RemoveTagButton onClick={(event) => handleRemoveTag(tag, event)}>
                                <CloseIcon />
                            </RemoveTagButton>
                        </TagPill>
                    ))}
                </TagsList>
            )}
            <AddButton onClick={handleAddTag}>+ Add</AddButton>
            {isModalOpen && (
                <TagEditorModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    selectedTags={getSelectedTagObjects()}
                    onSave={handleSaveTags}
                />
            )}
        </TagCategory>
    );
}); 